import React from 'react';

import cx from 'classnames';

import Table from 'components/shared/Table';

import { TravelBriefNavigation } from '../TravelBriefNavigation';
import { useTravelBriefTable } from './functions';
import s from './index.module.css';
import { EEventType } from './types';

const TravelBriefTable = () => {
  const {
    onChangeType,
    eventsType,
    activeType,
    accommodationColumns,
    regularColumns,
    flightColumns,
    fullSchedule,
    flightsSchedule,
    accommodationSchedule,
    wrapperRef,
  } = useTravelBriefTable();
  const withoutNavigation = eventsType.length === 1;
  const theadClassName = cx(s.thead, withoutNavigation && s.theadWithoutNavigation, 'custom-manifest-thead');

  return (
    <div className={s.wrapper} ref={wrapperRef}>
      <TravelBriefNavigation onChangeType={onChangeType} eventsType={eventsType} activeType={activeType} />
      {/*@ts-ignore*/}
      <Table
        theadClassName={theadClassName}
        tableClassName={cx(s.table, activeType === EEventType.All && s['table-active'], 'custom-manifest-table')}
        tableWrapperClassName={cx(s.tableWrapper)}
        columns={regularColumns}
        data={fullSchedule}
        withFixSizedColumns
      />
      {/*@ts-ignore*/}
      <Table
        theadClassName={theadClassName}
        tableClassName={cx(s.table, activeType === EEventType.Flight && s['table-active'], 'custom-manifest-table')}
        tableWrapperClassName={cx(s.tableWrapper)}
        columns={flightColumns}
        data={flightsSchedule}
        withFixSizedColumns
      />
      {/*@ts-ignore*/}
      <Table
        theadClassName={theadClassName}
        tableClassName={cx(
          s.table,
          s.accommodationsTable,
          activeType === EEventType.Accommodation && s['table-active'],
          'custom-manifest-table',
        )}
        tableWrapperClassName={cx(s.tableWrapper)}
        columns={accommodationColumns}
        data={accommodationSchedule}
        withFixSizedColumns
      />
    </div>
  );
};

export default TravelBriefTable;
